import React, { Component } from 'react'
import ContactForm from "./forms/contact";
import { Link } from "react-router-dom";

class ContactPage extends Component {
	render() {
		return (
			<div className="nf-page">
				<div className="nf-page-head">
					<p className="nf-eyebrow">Say hello</p>
					<h1>Contact</h1>
				</div>

				<div className="nf-two-col">
					<div>
						<p className="site-text">
							If you are interested in submitting your work for publication, visit the{' '}
							<Link to="/submissions">Submissions</Link> page. For all other comments or queries,
							reach out on social media, or fill out the form to send us an email.
						</p>
					</div>
					<div className="nf-surface">
						<ContactForm />
					</div>
				</div>
			</div>
		);
	}
}

export default ContactPage;
